import { render, staticRenderFns } from "./sendStationInfo.vue?vue&type=template&id=3c137c12&scoped=true"
import script from "./sendStationInfo.vue?vue&type=script&lang=js"
export * from "./sendStationInfo.vue?vue&type=script&lang=js"
import style0 from "./sendStationInfo.vue?vue&type=style&index=0&id=3c137c12&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c137c12",
  null
  
)

export default component.exports